import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-invoice-detail-cell-renderer',
  templateUrl: './invoice-detail-cell-renderer.component.html',
  styleUrls: ['./invoice-detail-cell-renderer.component.scss']
})
export class InvoiceDetailCellRendererComponent implements OnInit,OnDestroy {
params:any;
invoiceDetail:any = [];
invoice:any = [];
private destroy$ = new Subject<void>();
  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  agInit(param:any){
    this.params = param;
    this.invoice = this.params.data.Invoices?.split(',');
    this.invoice.forEach((el,index)=>{
      let split = el.split(':');
      if(el){        
        this.invoiceDetail.push({
          invoiceNo:split[0],
          poId:split[1] ? split[1] : split[0]
        })
      }
    })
  }

  navigate(invoiceId){
   this.router.navigate(['/forecasting/purchase-orders/detail/',invoiceId])
  }

  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
